import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./Login.css";

function ChangePassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setEmail(storedUser.email);
      setUser(storedUser);
    } else {
      navigate("/"); // redirect to login if no user
    }
  }, [navigate]);

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword) {
      Swal.fire("Error", "Please fill both password fields", "error");
      return;
    }

    try {
      // Step 1: Verify old password
      const verifyRes = await fetch("https://pbhrm.com/api/staff/login/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          password: oldPassword,
          device_token: "",
        }),
      });

      const verifyData = await verifyRes.json();

      if (verifyData.status !== 1) {
        Swal.fire("Error", "Old password is incorrect", "error");
        return;
      }

      // Step 2: Update password
      const updateRes = await fetch(`https://pbhrm.com/api/staff/${user.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
          password: newPassword,
          name: user.name,
          number: user.number,
          inside_outside: user.inside_outside || "inside",
        }),
      });

      const updateData = await updateRes.json();

      if (updateData.status === 1) {
        Swal.fire("Success", updateData.message, "success").then(() => {
          // Clear user and redirect to login
          localStorage.removeItem("user");
          navigate("/");
        });
      } else {
        Swal.fire("Error", updateData.message || "Failed to update password", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  };

  return (
    <div className="login-layout">
      <div className="login-left">
        <div className="image-grid">
          <img src="/assets/images/dada.jpeg" alt="temple" />
          <img src="/assets/images/mata1.jpeg" alt="temple" />
          <img src="/assets/images/mata.jpeg" alt="temple" />
        </div>
        <div className="guru-image">
          <img src="/assets/images/guru.jpeg" alt="temple" />
        </div>
      </div>

      <div className="login-right">
        <div className="logo">
          <img src="/assets/images/logo/logo1.png" alt="logo" />
          <h2>Padmavati Brothers</h2>
        </div>
        <div className="login-box">
          <h3>Change Password</h3>
          <form onSubmit={handleChangePassword}>
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              readOnly
            />
            <input
              type="password"
              placeholder="Old Password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <button type="submit">CHANGE PASSWORD</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
